import React, { createContext, useContext, useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { ValidateArPyramidGameCodeAsync } from '../services/games';

interface ArPyramidValidationContextType {
  gameCode: string;
  isValid: boolean;
}

const ArPyramidValidationContext =
  createContext<ArPyramidValidationContextType | null>(null);

interface ArPyramidValidationProviderProps {
  gameCode: string;
  children: React.ReactNode;
}

export const ArPyramidValidationProvider: React.FC<
  ArPyramidValidationProviderProps
> = ({ gameCode, children }) => {
  const { showBoundary } = useErrorBoundary();

  useEffect(() => {
    const validateGameCode = async () => {
      try {
        await ValidateArPyramidGameCodeAsync(gameCode);
      } catch (error: any) {
        // triggers ar.isArPyramid
        showBoundary({ ...error, isArPyramid: true });
      }
    };

    validateGameCode();
  }, [gameCode, showBoundary]);

  return (
    <ArPyramidValidationContext.Provider value={{ gameCode, isValid: true }}>
      {children}
    </ArPyramidValidationContext.Provider>
  );
};

export const useArPyramidValidation = () => {
  const context = useContext(ArPyramidValidationContext);
  if (!context) {
    throw new Error(
      'useArPyramidValidation must be used within ArPyramidValidationProvider'
    );
  }
  return context;
};
